"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Image = {};
var imageProps = {
  allegroImage: _propTypes["default"].bool,
  arrangedImage: _propTypes["default"].bool,
  altText: _propTypes["default"].string,
  originalSrc: _propTypes["default"].string.isRequired,
  variants: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    aspectRatio: _propTypes["default"].number,
    srcset: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      url: _propTypes["default"].string,
      w: _propTypes["default"].number,
      h: _propTypes["default"].number
    }))
  })),
  id: _propTypes["default"].string
};
Image.shape = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.length > 0 ? _propTypes["default"].shape(props.reduce(function (current, prop) {
    return _objectSpread(_objectSpread({}, current), {}, (0, _defineProperty2["default"])({}, prop, imageProps[prop]));
  }, {})) : _propTypes["default"].shape(imageProps);
};
var _default = Image;
exports["default"] = _default;